import { render, staticRenderFns } from "./EpisodesList.vue?vue&type=template&id=5a93a830&scoped=true"
import script from "./EpisodesList.vue?vue&type=script&lang=ts&setup=true"
export * from "./EpisodesList.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./EpisodesList.vue?vue&type=style&index=0&id=5a93a830&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a93a830",
  null
  
)

export default component.exports